import { useIntl } from 'react-intl';
import { TextColumn } from './TextColumn';

type DateTimeColumnProps = {
  value: string | undefined;
};

export const DateTimeColumn = ({ value }: DateTimeColumnProps) => {
  const intl = useIntl();
  const date = value ? new Date(value) : undefined;
  const formatted = date
    ? intl.formatDate(date, { dateStyle: 'medium', timeStyle: 'medium' })
    : '';

  return <TextColumn value={formatted.length ? formatted : '-'} />;
};
